import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

export const JourneySection = () => {
  const steps = [
    { icon: FiIcons.FiUsers, title: 'Meet', desc: 'Start with a real conversation.', color: 'text-meetoi-navy' },
    { icon: FiIcons.FiSmartphone, title: 'Share', desc: 'Share your digital profile in seconds.', color: 'text-meetoi-blue' },
    { icon: FiIcons.FiUserPlus, title: 'Connect', desc: 'They save your details instantly.', color: 'text-meetoi-navy' },
    { icon: FiIcons.FiFileText, title: 'Remember', desc: 'Capture notes and key details.', color: 'text-meetoi-blue' },
    { icon: FiIcons.FiBell, title: 'Follow Up', desc: 'Get reminded at the right time.', color: 'text-meetoi-navy' },
    { icon: FiIcons.FiHeart, title: 'Build Stronger Relationships', desc: 'Nurture connections that create impact.', color: 'text-meetoi-coral' }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-white border-b border-meetoi-aqua/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="mb-16">
          <h3 className="font-manrope text-[10px] font-bold uppercase tracking-widest text-meetoi-blue mb-2">The Relationship Journey</h3>
          <h2 className="font-sora text-3xl font-bold text-meetoi-navy">More than a card. A smarter way to build relationships.</h2>
        </div>

        <div className="relative">
          {/* Connecting Line (Desktop) */}
          <div className="hidden lg:block absolute top-8 left-12 right-12 h-0.5 border-t-2 border-dashed border-meetoi-aqua/50 z-0"></div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 lg:gap-4 relative z-10">
            {steps.map((step, idx) => (
              <div key={idx} className="flex flex-col items-center lg:items-start text-center lg:text-left">
                <div className="w-16 h-16 rounded-2xl bg-white border border-meetoi-aqua/30 shadow-sm flex items-center justify-center mb-6 relative">
                  <SafeIcon icon={step.icon} className={`text-2xl ${step.color}`} />
                  {/* Small decorative dot */}
                  {idx < steps.length - 1 && (
                    <div className="hidden lg:block absolute -right-2 top-1/2 -translate-y-1/2 translate-x-full w-2 h-2 rounded-full bg-meetoi-aqua/50"></div>
                  )}
                </div>
                <h4 className="font-sora font-semibold text-lg text-meetoi-navy mb-2">{step.title}</h4>
                <p className="font-manrope text-sm text-meetoi-text/70 font-medium">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};